import {Pipe, PipeTransform} from '@angular/core';
import {BusinessInitiationStatus} from '@services/resource/business-initiation-resource';

@Pipe({
  name: 'translateBIStatus',
  standalone: true,
})
export class BusinessStatusTranslate implements PipeTransform {
  transform(val: BusinessInitiationStatus): string {
    switch (val) {
      case BusinessInitiationStatus.keinKontakt:
        return 'kein Kontakt';
      case BusinessInitiationStatus.kontaktAufgenommen:
        return 'Kontakt aufgenommen';
      case BusinessInitiationStatus.listungsgespraeche:
        return 'Listungsgespräche';
      case BusinessInitiationStatus.listungGeplant:
        return 'Listung';
      case BusinessInitiationStatus.testlistung:
        return 'Testlistung';
      case BusinessInitiationStatus.wiederAusgelistet:
        return 'ausgelistet';
      default:
        return '';
    }
  }
}
